import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type TranscriptExportFailedAction = {
	type: 'TRANSCRIPT_EXPORT_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): TranscriptExportFailedAction => ({
	type: 'TRANSCRIPT_EXPORT_FAILED',
	payload,
});
